import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";
import useWindowSize from "../../_hooks/useWindowSize";

const TourImageSlider = ({ data }: { data: any[] }) => {
  const { width } = useWindowSize();
  return (
    <div style={{ position: "relative" }} className="tourSwiper">
      {data && data?.length > 0 ? (
        <>
          <Swiper
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            loop={true}
            breakpoints={{
              524: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              767: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
            }}
            navigation={{
              nextEl: ".tour-custom-next",
              prevEl: ".tour-custom-prev",
            }}
            modules={[
              // Autoplay,
              Navigation,
            ]}
          >
            {data?.map((tour: any, index: number) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <img
                    src={tour?.TourImage}
                    alt="banner Image"
                    className="w-100 tour-detaild-banner-image"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {width < 767 && (
            <div className={`tour-navigation-btn`}>
              <div className="swiper-button-prev tour-custom-prev">
                <span></span>
              </div>
              <div className="swiper-button-next tour-custom-next">
                <span></span>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="no-data-text">No Data Found</div>
      )}
    </div>
  );
};

export default TourImageSlider;
